import React from 'react';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="about-section section">
      <div className="container">
        <div className="about-grid">
          <div className="about-image">
            <img src="/images/chief.png" alt="About Foodea" />
          </div>
          
          <div className="about-content">
            <h2>About Foodea</h2>
            <p>Welcome to Foodea, where we celebrate the joy of cooking and sharing delicious meals with loved ones.</p>
            <p>Our mission is to inspire home cooks of all skill levels to create amazing dishes with easy-to-follow recipes using fresh, seasonal ingredients.</p>
            <p>Whether you're a beginner looking to learn the basics or an experienced chef seeking new inspiration, Foodea is your trusted companion in the kitchen.</p>
            <p>Every recipe on our website is carefully tested and perfected to ensure your cooking success.</p>
            
            <div className="about-stats">
              <div className="stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">Recipes</span>
              </div>
              <div className="stat">
                <span className="stat-number">100K+</span>
                <span className="stat-label">Happy Cooks</span>
              </div>
              <div className="stat">
                <span className="stat-number">15+</span>
                <span className="stat-label">Categories</span>
              </div>
            </div>
            
            <Link to="/about" className="btn">Learn More</Link>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .about-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: center;
        }
        
        .about-image img {
          width: 100%;
          height: auto;
          border-radius: 8px;
        }
        
        .about-content h2 {
          font-size: 2.5rem;
          margin-bottom: 1.5rem;
          position: relative;
        }
        
        .about-content h2::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 60px;
          height: 3px;
          background-color: var(--primary-color);
        }
        
        .about-content p {
          margin-bottom: 1rem;
          color: var(--gray);
          line-height: 1.8;
        }
        
        .about-stats {
          display: flex;
          margin: 2rem 0;
        }
        
        .stat {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 1.5rem;
          background-color: var(--light-color);
          border-radius: 8px;
          margin-right: 1rem;
        }
        
        .stat:last-child {
          margin-right: 0;
        }
        
        .stat-number {
          font-size: 2rem;
          font-weight: 700;
          color: var(--primary-color);
        }
        
        .stat-label {
          font-size: 0.9rem;
          color: var(--gray);
        }
        
        @media (max-width: 992px) {
          .about-grid {
            grid-template-columns: 1fr;
          }
          
          .about-image {
            order: 2;
          }
          
          .about-content {
            order: 1;
          }
          
          .about-stats {
            flex-wrap: wrap;
          }
          
          .stat {
            flex: 0 0 calc(50% - 1rem);
            margin-bottom: 1rem;
          }
        }
        
        @media (max-width: 576px) {
          .stat {
            flex: 0 0 100%;
            margin-right: 0;
          }
        }
      `}</style>
    </section>
  );
};

export default AboutSection;